import { Link } from "react-router-dom";
import { BrandLogo } from "./BrandLogo";
import { useSiteConfig } from "../hooks/useSiteConfig";

export function SiteFooter() {
  const site = useSiteConfig();
  return (
    <footer className="mt-24 bg-brand-ink text-brand-paper">
      <div className="container-emjc grid gap-10 py-16 md:grid-cols-[2fr_1fr_1fr_1fr]">
        <div>
          {/* Logo institucional en variante "inverse": silueta y texto en
              blanco para que se lea sobre el fondo oscuro brand-ink. */}
          <BrandLogo variant="inverse" height={72} />
          <p className="mt-4 max-w-sm text-sm text-gray-300">{site.description}</p>
        </div>
        <div>
          <h3 className="text-sm font-semibold uppercase tracking-widest text-accent-sun">
            Navegar
          </h3>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/proyecto" className="hover:text-brand-orange">El proyecto</Link></li>
            <li><Link to="/programas" className="hover:text-brand-orange">Programas</Link></li>
            <li><Link to="/noticias" className="hover:text-brand-orange">Noticias</Link></li>
            <li><Link to="/eventos" className="hover:text-brand-orange">Eventos</Link></li>
            <li><Link to="/galeria" className="hover:text-brand-orange">Galería</Link></li>
            <li><Link to="/contacto" className="hover:text-brand-orange">Contacto</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="text-sm font-semibold uppercase tracking-widest text-accent-sun">
            Síguenos
          </h3>
          <ul className="mt-4 space-y-2 text-sm">
            <li>
              <a href={site.social.facebook.url} target="_blank" rel="noreferrer" className="hover:text-brand-orange">
                Facebook · {site.social.facebook.label}
              </a>
            </li>
            <li>
              <a href={site.social.instagram.url} target="_blank" rel="noreferrer" className="hover:text-brand-orange">
                Instagram · {site.social.instagram.label}
              </a>
            </li>
            <li>
              <a href="https://campusemjc.unex.es/moodle/" target="_blank" rel="noreferrer" className="hover:text-brand-orange">
                Campus virtual (Moodle)
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="text-sm font-semibold uppercase tracking-widest text-accent-sun">
            Contacto
          </h3>
          <ul className="mt-4 space-y-2 text-sm">
            <li>
              <a href={`mailto:${site.email}`} className="hover:text-brand-orange">
                {site.email}
              </a>
            </li>
            <li className="text-gray-300">{site.university}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-emjc flex flex-col items-center justify-between gap-3 py-6 text-xs text-gray-300 md:flex-row">
          <p>© {new Date().getFullYear()} {site.longName} · Universidad de Extremadura</p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/aviso-legal" className="hover:text-brand-orange">Aviso legal</Link>
            <Link to="/politica-privacidad" className="hover:text-brand-orange">Privacidad</Link>
            <Link to="/cookies" className="hover:text-brand-orange">Cookies</Link>
            <Link to="/accesibilidad" className="hover:text-brand-orange">Accesibilidad</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
